import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const TextFieldGroup = ({field, value, label, placeholder, error, type, onChange, onBlur, pattern, disabled, className, addOn}) => {
  return (
    <div className={classnames('form-group', {'has-error': error}, {[className]: className})}>
      {label && <label>{label}</label>}
      <div className="input-group">
{addOn &&   <div className="input-group-prepend">
<span className="input-group-text" >{addOn}</span>
</div>}

  <input
      
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        type={type}
        name={field}
        placeholder={placeholder}
        className="form-control"
        pattern={pattern}
        disabled={disabled}
      />
      {error && <span className="text-danger">{error}</span>}
</div>
     
    </div>
  );
};

TextFieldGroup.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  checkUserExists: PropTypes.func
};

TextFieldGroup.defaultProps = {
  type: 'text',
  disabled: false
};

export default TextFieldGroup;
